import { render, staticRenderFns } from "./classroom.vue?vue&type=template&id=b7f82100&scoped=true"
import script from "./classroom.vue?vue&type=script&lang=js"
export * from "./classroom.vue?vue&type=script&lang=js"
import style0 from "./classroom.vue?vue&type=style&index=0&id=b7f82100&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f82100",
  null
  
)

export default component.exports